var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "brb-modal",
    {
      ref: "brb-modal",
      attrs: {
        title: "قرارداد",
        centered: "",
        size: "lg",
        "no-close-on-backdrop": "",
        "no-activator": "",
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "d-flex justify-content-center p-4" },
                [
                  _c(
                    "brb-btn",
                    {
                      staticClass: "py-2 text-center",
                      attrs: { variant: "brb-secondary" },
                      on: { click: _vm.submitTermsAndConditions },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("shared.accept")) + " ")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "b-overlay",
        { staticClass: "p-4", staticStyle: { "white-space": "pre-line" } },
        [_vm._v(" " + _vm._s(_vm.$t("account.conditions")) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }